import React, { Fragment, useEffect, useState } from 'react';
import {SzButton, SzSelect, SzIcon} from '@suezenv/react-theme-components'
import {IOptionsFavoriteFilter, ISignalAdvancedFavoriteFilters, IFavoriteFilterOptions, ISignalFavoriteFilters} from "../../../../type/signal.type";
import './signal-advanced-filter.scss';
import { useTranslationWithPrefix } from '../../../../hooks/translation';
import EditFilterModal from './modals/edit-filter-modal';

export const FavoriteFilters : React.FC<ISignalFavoriteFilters> = ({
	selectedFavoriteFilterOption,
	setSelectedFavoriteFilterOption,
	favoriteFiltersList,
	setFavoriteFiltersList,
	selectedFavoriteFilter,
	setSelectedFavoriteFilter
}) => {
	const trans = useTranslationWithPrefix("signalement", "form_filter");
	const [showEditModal, setShowEditModal] = useState(false);
	const [countFilters, setCountFilters] = useState<{ label: string; value: number }[]>([]);

	const updateCountFilters = () => {
		let countFiltersTemp: { label: string; value: number }[] = [];
		favoriteFiltersList.forEach((filter: ISignalAdvancedFavoriteFilters) => {
			if (filter && filter.label) {
				let countActiveFilters = 0;
				if (filter.address) countActiveFilters++;
				if (filter.requestTypes && filter.requestTypes.length > 0) countActiveFilters++;
				if (filter.status && filter.status.length > 0) countActiveFilters++;
				if (filter.radius) countActiveFilters++;
				countFiltersTemp.push({label: filter.label, value: countActiveFilters});
			}
		});
		setCountFilters(countFiltersTemp);
	};
	
	const handleFavoriteFiltersChange = (selectedOption: IOptionsFavoriteFilter) => {
		const selectedFavoriteFilter = favoriteFiltersList.find(item => item.label === selectedOption?.value) ?? null;
		setSelectedFavoriteFilterOption(selectedFavoriteFilter);
	};

	const getFavoriteFiltersOptions = (favoriteFilters: ISignalAdvancedFavoriteFilters[]): IFavoriteFilterOptions[] => {
		let favoriteFiltersOptions: IFavoriteFilterOptions[] = [];
		favoriteFilters.forEach((filter: ISignalAdvancedFavoriteFilters) => {
			if (filter && filter.label) {
				favoriteFiltersOptions.push({
					id: filter.label,
					label: filter.label,
					value: filter.label,
					text: countFilters.find(item => item.label === filter.label) 
						? ` ${countFilters.find(item => item.label === filter.label)?.value} filtres` 
						: ''
				});
			}
		});
		return favoriteFiltersOptions;
	}

	const deleteFavoriteFilter = () => {
		if (!selectedFavoriteFilterOption) return;

		const newFavoriteFilterList = favoriteFiltersList.filter(filter => filter.label !== selectedFavoriteFilterOption.label);
		setSelectedFavoriteFilter(null);
		setSelectedFavoriteFilterOption(null);
		setShowEditModal(false);
		setFavoriteFiltersList(newFavoriteFilterList);
	};

	const editFavoriteFiltersLabel = (favoriteFilterLabel: string) => {
		if (!selectedFavoriteFilterOption) return;

		const updatedList = favoriteFiltersList.map(filter =>
			filter.label === selectedFavoriteFilterOption.label
				? { ...filter, label: favoriteFilterLabel }
				: filter
		);
		setFavoriteFiltersList(updatedList);
		setSelectedFavoriteFilterOption(selectedFavoriteFilterOption
			? { ...selectedFavoriteFilterOption, label: favoriteFilterLabel }
			: null
		);
		setSelectedFavoriteFilter(selectedFavoriteFilter
			? { ...selectedFavoriteFilter, label: favoriteFilterLabel }
			: null
		);
	};

	useEffect(() => {
		if (selectedFavoriteFilter) {
			setSelectedFavoriteFilterOption(selectedFavoriteFilter);
		}
	}, [selectedFavoriteFilter]);

	useEffect(() => {
		updateCountFilters();
	}, [favoriteFiltersList]);

	return (
		<Fragment>
			<SzIcon variant="line" icon="filter-1" className='mr-1' />
			<div style={{ flexGrow: 1, maxWidth: '200px' }}>
				<SzSelect
					key={selectedFavoriteFilterOption ? selectedFavoriteFilterOption.label : 'reset'}
					id={'favorite-filters'}
					placeholder={trans('advanced_filters.favorite_filters')}
					options={getFavoriteFiltersOptions(favoriteFiltersList)}
					onChange={handleFavoriteFiltersChange}
					defaultValue={selectedFavoriteFilterOption}
					name={'input-2'}
					isSearchable
				/>
			</div>
			<SzButton
				variant="tertiary"
				className="mr-2"
				icon="cog"
				onClick={() => {
					setShowEditModal(true);
				}}
				isDisabled={selectedFavoriteFilterOption ? false : true}>
			</SzButton>
			<EditFilterModal
					setShowEditModal={setShowEditModal}
					showEditModal={showEditModal}
					deleteFavoriteFilter={deleteFavoriteFilter}
					editFavoriteFiltersLabel={editFavoriteFiltersLabel}
					selectedFavoriteFilterLabel={selectedFavoriteFilterOption?.label ?? ""}
			/>
		</Fragment>
	);
};

export default FavoriteFilters;